<template>
  <section class="worth">
    <div class="container">
      <a-typography-title :level="1">
        产品价值
      </a-typography-title>
      <a-typography-paragraph>
        覆盖成本、算力、稳定性等业务关键点的一站式智能运维平台
      </a-typography-paragraph>
      <div class="box_list">
        <div v-for="(item,index) in expand.list" ref="item"
             class="item" :class="[`i_${index+1}`,index+1===expand.active?'active':'']">
          <a-typography-title :level="5">
            {{ item.title }}
          </a-typography-title>
          <a-typography-paragraph>
            <p v-for="v in item.text">
              {{ v }}
            </p>
          </a-typography-paragraph>
        </div>
      </div>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_3"
                  @click="$RQ.GoGSS()">
          免费试用
        </a-button>
        <a-button type="link" class="button_n_3"
                  @click="$Store.Page().openModal('modalFormCollection', 'demo')">
          预约咨询
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_worth',
  data(): DataInterface {
    return {
      expand: {
        active: 1,
        list: [
          {
            title: '成本优化',
            text: [
              '成本洞察：成本分布和趋势可视化',
              '最佳用云实践：帮助节省云上开销',
              '体检和报告：诊断可优化空间',
              '专业的成本优化服务'
            ]
          },
          {
            title: '算力治理',
            text: [
              '多云管理：统一权限与资源管理',
              '算力模板：屏蔽云平台差异',
              '资源规格智能推荐',
              '算力共享池建设'
            ]
          },
          {
            title: '稳定性治理',
            text: [
              '基于业务特点的指标洞察',
              '指标监控及告警功能',
              '业务排名及改进建议',
              '定制化自动治理策略'
            ]
          },
          {
            title: '数据容灾备份',
            text: [
              '高可用等级定义',
              '跨区域高速数据传输网',
              '数据恢复中心建设'
            ]
          },
          {
            title: '业务架构治理',
            text: [
              '业务价值指标识别',
              '架构选型及优化指导',
              'Serverless化改造建议'
            ]
          }
        ]
      }
    };
  },
  mounted(): void {
    this.listenMouseOver();
  },
  methods: {
    /**
     * 监听鼠标移动
     */
    listenMouseOver(): void {
      this.$refs.item.forEach((v: HTMLElement, i: number) => {
        v.addEventListener('mouseover', () => {
          this.expand.active = i + 1;
        }, false)
      });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';


@image: '@{src_image}page/productSchedulX/';
@border: 1px solid @color_14;

.worth {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.box_list {
  overflow: hidden;
  position: relative;
  margin: @margin_mo 0 0;
  border: @border;
  .borderBox();
  .shadow(0 0 20px fade(@color_black, 5));
}

.item {
  @style: width @time, background @time;
  float: left;
  overflow: hidden;
  position: relative;
  width: 17.5%;
  height: 360px;
  .bg('@{image}worth_item_bg.jpg');
  background-size: cover;
  //.transition(@style);
  
  .loop(@i) when (@i<=5) {
    &.i_@{i} {
      border-left: if(@i>1, @border, none);
      border-right: if(@i<5, @border, none);
      
      h5.ant-typography::before {
        .bg('@{image}worth_icon_@{i}.png', 160px, 150px, true);
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &.active {
    width: 30%;
    background: @color_white;
    
    h5.ant-typography {
      .transform(translate(-50%, calc(~'-50% - 65px')));
    }
    
    div.ant-typography {
      opacity: 1;
      .transform(translate(-50%, -65px));
    }
  }
  
  h5.ant-typography {
    .center();
    z-index: 1;
    .font(center, @text_big+4px, @color_12, @text_big+4px, true);
    .transition(transform @time);
    
    &::before {
      content: '';
      display: block;
      margin: 0 auto @margin_mo;
    }
  }
  
  div.ant-typography {
    @h: 130px;
    @style: opacity @time, transform @time;
    .position(absolute, auto, auto, -65px, 50%);
    z-index: 1;
    width: 260px;
    height: @h;
    margin: 0 auto;
    .font(justify, @text+@line, @color_13, @text);
    opacity: 0;
    .transform(translate(-50%, 0));
    .transition(@style);
    
    p {
      position: relative;
      padding-left: 15px;
      margin: 0;
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 10px, auto, auto, 0);
        width: 4px;
        height: 4px;
        background: @color_6;
        border-radius: 50%;
      }
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_lg) {
  .box_list {
    overflow: initial;
    border: none;
    .shadow(none);
  }
  
  .item {
    float: none;
    width: 100% !important;
    max-width: 360px;
    height: auto;
    padding: 160px 0 20px;
    margin: 20px auto 0;
    background: @color_white;
    border: @border !important;
    .shadow(0 0 20px fade(@color_black, 5));
    
    &:nth-child(1) {
      margin-top: 0;
    }
    
    .loop(@i) when (@i<=5) {
      &.i_@{i} {
        @style: 0.6px;
        
        h5.ant-typography::before {
          .bg('@{image}worth_icon_@{i}.png', 160px*@style, 150px*@style, true);
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    h5.ant-typography {
      .position(top, 20px);
      .transform(translate(0, 0)) !important;
    }
    
    div.ant-typography {
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: auto;
      opacity: 1 !important;
      .transform(translate(0, 0)) !important;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .worth {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  div.ant-typography {
    .font(center, @text_big_mo+@line_mo, @color_12, @text_big_mo);
  }
  
  .item {
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>